import { Injectable } from '@angular/core';
import {FirestoreService} from "./firestore.service";
import {take} from "rxjs/operators";
import {FirebaseAuthService} from "../auth/firebase-auth.service";

@Injectable({
  providedIn: 'root'
})
export class LocalService {

  membership: any = null;
  institution: any = null;

  constructor(
    private firestoreService: FirestoreService,
    private firebaseAuthService: FirebaseAuthService
  ) { }

  clearData() {
    this.membership = null;
    this.institution = null;
  }

  async getMembership() {
    if(this.membership) {
      return this.membership;
    } else {
      this.membership = await this.getMembershipFromServer();
      return this.membership;
    }
  }

  async getMembershipFromServer() {
    return new Promise(async (resolve, reject) => {
      const user = await this.firebaseAuthService.currentUser;
      if (user) {

        const token = await user.getIdTokenResult();
        let queryArray = [];
        if(token.claims.institution) {
          const institution = token.claims.institution;
          const query = {
            field: 'institution',
            operator: '==',
            value: institution
          }
          queryArray.push(query);
        } else {
          const query = {
            field: 'createdBy',
            operator: '==',
            value: user.uid
          }
          queryArray.push(query);
        }

        await this.firestoreService.getAllOnceBy('memberships', queryArray, 'created', 'desc')
          .subscribe((membershipsSnapshot) => {
            if (membershipsSnapshot.length > 0) {
              let membership: any = membershipsSnapshot[0].payload.doc.data();
              membership.id = membershipsSnapshot[0].payload.doc.id;
              resolve(membership);
            } else {
              resolve(null);
            }

          }, (err) => {
            console.log('could not get membership', err);
            reject(err);
          });
      }
    });
  }

  async getInstitution() {
    if(this.institution) {
      return this.institution;
    } else {
      this.institution = await this.getInstitutionFromServer();
      return this.institution;
    }
  }

  async getInstitutionFromServer() {
    return new Promise(async (resolve, reject) => {
      const user = await this.firebaseAuthService.currentUser;
      if (user) {
        const token = await user.getIdTokenResult();
        const queryArray = [];
        if(token.claims.institution) {
          await this.firestoreService.getByIdValueChangesOnce('institutions', token.claims.institution)
            .subscribe((institution) => {
              if (institution) {
                this.institution = institution;
                resolve(institution);
              } else {
                resolve(null);
              }
            }, (err) => {
              console.log('could not get institution', err);
              reject(err);
            });
        } else {
          resolve(null);
        }
      }
    });
  }
}
